import { createFileRoute } from '@tanstack/react-router';

type Search = {
  locationId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence/follow-ups_/$type')({
  validateSearch: (search: Search): Search => {
    return {
      locationId: search.locationId,
    };
  },
});
